import React, { useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Button, Card, CardBody, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBannerById, fetchBannerList } from './redux/dispatcher';

export default function ShowBanner() {
    const dispatch = useDispatch()
    const bannerList = useSelector((state) => state.bannerReducer.banners) || [];
    const loading = useSelector((state) => state.bannerReducer.loading);
    

    useEffect(() => {
        dispatch(fetchBannerList())
    }, [])

    const handleDelete = (id) => {
        dispatch(deleteBannerById(id))
    }

    const truncateString = (str, maxLength)=> {
        // Check if the string length exceeds the specified maximum length
        if (str.length > maxLength) {
            // Return the truncated string with ellipsis
            return str.substring(0, maxLength) + '...';
        }
        // If the string length is within the limit, return it as is
        return str;
    }
    return (
        <>
            {bannerList.length > 0 ?

                <div className="container-fluid d-flex  justify-content-between " >

                    <div className="card-wrapper" >
                        <Card className="">
                            {/* <CardBody> */}
                            <Carousel
                                autoPlay={true}
                                infiniteLoop={true}
                                autoFocus={true}
                            >
                                {
                                    bannerList.map((item) => (
                                        <div>
                                            <img src={item?.img_path} alt="Legend 1" />
                                            <p style={{color:'black'}}>{item?.name}</p>
                                        </div>
                                    ))
                                }
                            </Carousel>

                            {/* </CardBody> */}
                        </Card>
                    </div>
                    <div className="" style={{ width: '40%', marginTop: '0', maxHeight: '400px', overflowY: 'auto' }}>
                        <Card style={{ width: '100%' }}>
                            <CardBody>
                                {
                                    bannerList.map((item) => (
                                        <div className="item-wrapper">
                                            <h4>{truncateString(item?.name, 20)}</h4>
                                            <Button className='btn btn-danger' disabled={loading} onClick={() => handleDelete(item?.id)}>
                                                {loading ? <Spinner size="sm" /> : <i className="fa-solid fa-trash"></i>}
                                            </Button>{' '}
                                        </div>
                                    ))
                                }
                            </CardBody>
                        </Card>
                    </div>
                </div>
                : <h1 className='text-center'>No Banner for Slider</h1>
            }

        </>
    );
}

